import styled from 'styled-components'
import Browser from '../../../../services/Browser'
import { breakpoints } from '../../../../constants'

export const StyledForm = styled.form`
	display: ${Browser.isIE() ? 'flex' : 'grid'};
	flex-wrap: wrap;
	grid-gap: 4rem 15px;

	@media screen and (min-width: ${breakpoints.MOBILE}px) {
		grid-template-columns: repeat(3, 1fr);

		.buttons {
			width: 100%;
			grid-column: 1 / -1;
		}
	}

	& > * {
		margin-bottom: ${Browser.isIE() ? '4rem' : null};
		width: ${Browser.isIE() ? 'calc((100% / 3) - 15px)' : null};

		&:not(:last-child) {
			margin-right: ${Browser.isIE() ? '15px' : null};
		}
	}

	.buttons {
		display: flex;
		justify-content: flex-end;
		margin-bottom: 4rem;

		& > :first-child {
			margin-right: 15px;
		}
	}
`
